import { fetchDreamCityNewUserInfo2, fetchDreamCityNewInfo, fetchDreamCityNewRankList, fetchDreamCityNewReceive } from '@/services/activity';
import { Toast } from 'antd-mobile';

export default {
  namespace: 'dreamCityNew',
  state: {
    activityId: '',
    title: '',
    titleUrl: '',
    endTime: 0,
    rules: '',
    supplyRules: '',
    supplySendGiftList: {},
    supplyReceivedGiftList: {},
    lastRoomId: '',
    userInfo: {},
    activityStatus: 0,
    giftList: [],
    sendRewardList: [],
    receiveRewardList: [],
    rankList: [],
    selfRank: {},
    currentValue: 0,
    supportUser: {},
    targetRewardList: [],
  },
  reducers: {
    updateDetail(state, { payload }) {
      return {
        ...state,
        activityId: payload.activityId || '',
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        endTime: payload.endTime || '',
        rules: payload.rules || '',
        supplyRules: payload.supplyRules || '',
        supplySendGiftList: payload.supplySendGiftList || {},
        supplyReceivedGiftList: payload.supplyReceivedGiftList || {},
        lastRoomId: payload.lastRoomId || '',
        userInfo: payload.userInfo || {},
        activityStatus: payload.activityStatus || 1,
        giftList: payload.giftList || [],
        sendRewardList: payload.sendRewardList || [],
        receiveRewardList: payload.receiveRewardList || [],
      };
    },
    updateList(state, { payload }) {
      let targetRewardList = [];
      if (payload && payload.rankList && payload.rankList.length) {
        let ind = payload.rankList.findIndex(item => !item.target);
        if (ind === -1) {
          ind = payload.rankList.length;
        }
        targetRewardList = payload.rankList.splice(0, ind);
      }
      return {
        ...state,
        targetRewardList,
        selfRank: payload.selfRank || {},
        rankList: payload.rankList || [],
      };
    },
    updateUserInfo(state, { payload }) {
      return {
        ...state,
        currentValue: payload.currentValue,
        supportUser: payload.supportUser,
      };
    },
  },
  effects: {
    *getDetail({ payload }, { call, put }) {
      const { data, error } = yield call(fetchDreamCityNewInfo, payload);
      if (error) {
        yield put({
          type: 'updateDetail',
          payload: {},
        });
        Toast.show({
          content: error,
        });
        return error;
      }
      yield put({
        type: 'updateDetail',
        payload: data,
      });
      return true;
    },
    *getRewads({ payload }, { call }) {
      const { error, data } = yield call(fetchDreamCityNewReceive, payload);
      if (error) {
        return {
          success: false,
          error,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *getList({ payload }, { call, put, select }) {
      const { error, data } = yield call(fetchDreamCityNewRankList, { ...payload, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data },
      });
      return true;
    },
    *getUserInfo({ payload }, { call, put, select }) {
      const { error, data } = yield call(fetchDreamCityNewUserInfo2, payload);
      if (error || !data) {
        yield put({
          type: 'updateUserInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return;
      }
      yield put({
        type: 'updateUserInfo',
        payload: data,
      });
      return data;
    },
  },
};
